module.exports = __webpack_public_path__ + "img/gold.b7e8b767.svg";